import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppInsightsContext } from './app-insights-context';
import { RootState } from '../../store/root-reducer';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const useTrackCotapEvent = (eventName: string, eventData: any) => {
    const [data, setData] = useState(eventData);
    const { hospitalName, payPeriodStart, payPeriodEnd } = useSelector((state: RootState) => state.pendingTimesheets);
    const reactPlugin = useAppInsightsContext();

    useEffect(() => {
        if (!data) {
            return;
        }

        reactPlugin.trackEvent({ name: eventName }, { error: data, hospitalName, payPeriodStart, payPeriodEnd });
    }, [reactPlugin, data, eventName, hospitalName, payPeriodStart, payPeriodEnd]);

    return setData;
};
